import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import countriesList from "../../../data/countriesList";
import states from "../../../data/states";
import { useEffect } from "react";
import findBrand from "../../findBrand";
import { brandDomains, fetchBrands } from "../../brand";

const R5MailingAddress = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    formData: {
      mailingStreet,
      firstName,
      mailingCity,
      mailingState,
      mailingZip,
      mailingCountry,
      liveinUS,
      mailingaddressfield,
    },
    onFormDataChange,
    pass: { address1 },
  } = registrationContext;

  const [countries, setCountries] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [country, setCountry] = useState(mailingCountry || ""); // Initialize with stored value
  const [Cstate, setState] = useState(mailingState || ""); // Initialize with stored value
  const [touched, setTouched] = useState("");

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        "https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/master/json/countries%2Bstates.json"
      );
      const data = await response.json();

      // Reorder countries to have "United States" at the top
      const reorderedCountries = data.sort((a, b) =>
        a.name === "United States" ? -1 : b.name === "United States" ? 1 : 0
      );

      setCountries(reorderedCountries);

      // Set filtered states if a country is already selected
      if (mailingCountry) {
        const countryData = reorderedCountries.find(
          (item) => item.name === mailingCountry
        );
        if (countryData?.states) {
          const stateNames = countryData.states.map((state) =>
            typeof state === "object" ? state.name : state
          );
          setFilteredStates(stateNames);
        } else {
          setFilteredStates([]);
        }
      }
    };

    fetchData();
  }, [mailingCountry]);

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;

    // Only update if country is actually changed
    if (selectedCountry !== mailingCountry) {
      setCountry(selectedCountry);
      const countryData = countries.find(
        (item) => item.name === selectedCountry
      );
      if (countryData?.states) {
        const stateNames = countryData.states.map((state) =>
          typeof state === "object" ? state.name : state
        );
        setFilteredStates(stateNames);
      } else {
        setFilteredStates([]);
      }

      onFormDataChange({
        target: { name: "mailingCountry", value: selectedCountry },
      });
      onFormDataChange({ target: { name: "mailingZip", value: "" } });
      setTouched("");
      setState("");
    }
  };

  const handleStateChange = (e) => {
    setState(e.target.value);
    onFormDataChange({
      target: { name: "mailingState", value: e.target.value },
    });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const validatezipCode = (e) => {
    const re = /^\d{5}$/;
    return re.test(String(e).toLowerCase());
  };

  const validateZipCode = (mailingZip) => {
    //holston and pbia Forms
    if (country === "United States") {
      return /^\d{5}$/.test(mailingZip); // USA ZIP Code: Exactly 5 digits
    }
    return /^\d{0,15}$/.test(mailingZip);
  };

  const handleZipChange = (e) => {
    let { value } = e.target;

    if (mailingCountry === "United States") {
      // Trim ZIP code to 5 digits if exceeded
      value = value.replace(/\D/g, "").slice(0, 5);
    } else {
      // Trim ZIP code to 15 digits for other countries
      value = value.replace(/\D/g, "").slice(0, 15);
    }

    onFormDataChange({ target: { name: "mailingZip", value } });
  };

  const handleChange1 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      var aVal = e.target.value;
      if (aVal.length < 5) {
        e.target.value = aVal;
      }
    }
    onFormDataChange(e);
  };

  const mailingAddressfilled =
    mailingStreet !== "" &&
    mailingCity !== "" &&
    mailingState !== "" &&
    mailingZip !== "" &&
    validatezipCode(mailingZip) &&
    mailingCountry !== "";

  const mailingAddressfilled2 =
    mailingStreet !== "" &&
    mailingCountry !== "" &&
    mailingCity !== "" &&
    mailingState !== "" &&
    mailingZip !== "" &&
    validateZipCode(mailingZip);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  //findBrand is used to check whether holston forms or other forms
  if (findBrand(brand_holston) === true || findBrand(brand_pbia) === true) {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Mailing Address <span>(6/11)</span>
            <hr />
          </h2>

          <div className="item">
            <div className="asterisk-group">
              <h3>Mailing Street</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="mailingStreet"
              maxLength="50"
              onChange={(e) => onFormDataChange(e)}
              value={mailingStreet}
              style={{
                border: address1
                  ? "1px solid #ccc;"
                  : mailingStreet !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Mailing City/Town</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="mailingCity"
              maxLength="50"
              onChange={(e) => onFormDataChange(e)}
              value={mailingCity}
              style={{
                border: address1
                  ? "1px solid #ccc;"
                  : mailingCity !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>
          <div className="item">
            <div className="asterisk-group">
              <h3>Mailing Country</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="mailingCountry"
              value={mailingCountry}
              onChange={handleCountryChange}
              style={{
                border: address1
                  ? "1px solid #ccc;"
                  : country !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select</option>
              {countries.map((item) => (
                <option key={item.name} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* State Selector */}
          <div className="item">
            <div className="asterisk-group">
              <h3>Mailing State/Province/Region</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="Cstate"
              value={Cstate}
              onChange={handleStateChange}
              style={{
                border: address1
                  ? "1px solid #ccc;"
                  : Cstate !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select</option>
              {filteredStates.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3> Mailing Zip/Postal </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="mailingZip"
              required
              onChange={handleZipChange}
              value={mailingZip}
              maxLength={mailingCountry === "United States" ? "5" : "15"} // Ensures correct max length
              style={{
                border: address1
                  ? "1px solid #ccc"
                  : mailingZip !== ""
                  ? "1px solid #ccc"
                  : "2px solid #d8302f",
              }}
            />
            {mailingZip !== "" && !validateZipCode(mailingZip) && (
              <p className="validEmail">
                Please provide a valid Zip/Postal Code
              </p>
            )}
          </div>
        </div>

        <ProgressButtons validation={mailingAddressfilled2} name="address1" />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Mailing Address <span>(4/15)</span>
            <hr />
          </h2>
          <div className="group">
            <div>
              <div className="item">
                <div className="asterisk-group">
                  <h3>Mailing Street</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  maxLength="50"
                  name="mailingStreet"
                  onChange={(e) => onFormDataChange(e)}
                  value={mailingStreet}
                  style={{
                    border: address1
                      ? "1px solid #ccc;"
                      : mailingStreet !== ""
                      ? "1px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                />
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3>Mailing City</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  name="mailingCity"
                  maxLength="50"
                  onChange={(e) => onFormDataChange(e)}
                  value={mailingCity}
                  style={{
                    border: address1
                      ? "1px solid #ccc;"
                      : mailingCity !== ""
                      ? "1px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                />
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3>Mailing State</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  name="mailingState"
                  value={mailingState}
                  onChange={(e) => onFormDataChange(e)}
                  style={{
                    border: address1
                      ? "1px solid #ccc;"
                      : mailingState !== ""
                      ? "1px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                >
                  <option value="">Please Select </option>
                  {states.map((item) => {
                    return (
                      <option value={Object.keys(item)}>
                        {Object.keys(item)}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3>Mailing Zip</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  name="mailingZip"
                  maxLength="5"
                  required
                  value={mailingZip}
                  onChange={(e) => handleChange1(e)}
                  style={{
                    border: address1
                      ? "1px solid #ccc;"
                      : mailingZip !== ""
                      ? "1px solid #ccc;"
                      : "#d8302f 2px solid",
                  }}
                />
                {mailingZip !== "" && !validatezipCode(mailingZip) && (
                  <p className="validEmail">
                    {` Please provide a valid Zip/Postal Code`}
                  </p>
                )}
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3> Mailing Country</h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  name="mailingCountry"
                  value={mailingCountry}
                  type="text"
                  onChange={(e) => onFormDataChange(e)}
                  style={{
                    border: address1
                      ? "1px solid #ccc;"
                      : mailingCountry !== ""
                      ? "1px solid #ccc;"
                      : "#d8302f 2px solid",
                  }}
                >
                  <option value="">Please Select </option>
                  {countriesList.map((item) => {
                    return <option value={item}>{item}</option>;
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
        <ProgressButtons validation={mailingAddressfilled} name="address1" />
      </>
    );
  }
};

export default R5MailingAddress;
